import { Box } from '@material-ui/core';

import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

interface ValidationButtonsProps {
  onValidate: () => void;
  onDoNotValidate: () => void;
  disabled: boolean;
}

export const ValidationButtons = ({ onValidate, onDoNotValidate, disabled }: ValidationButtonsProps) => {
  const { palette } = useCustomTheme();
  const { lg } = useScreen();

  return (
    <Box display="flex" flexDirection={!lg ? 'column' : 'row'} justifyContent={'flex-end'} gridGap={8} width={'100%'}>
      <StandardButton
        main
        endIcon={<Icon size={20}>close</Icon>}
        onClick={onDoNotValidate}
        disabled={disabled}
        style={{ backgroundColor: palette.error.main }}
      >
        <Text tId={'DO_NOT_VALIDATE'} />
      </StandardButton>
      <StandardButton
        main
        onClick={onValidate}
        disabled={disabled}
        endIcon={<Icon size={20}>check</Icon>}
        style={{ backgroundColor: palette.success.main }}
      >
        <Text tId={'VALIDATE'} />
      </StandardButton>
    </Box>
  );
};
